import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { GenericMessageResponse } from './models/responses/generic-message-response';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpService {

  private httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };
  constructor(private httpClient: HttpClient) { }
  public get<T>(path: string, params?: any, response = 'json'): Observable<T> {
    return this.httpClient.get<GenericMessageResponse<T>>(environment.api.baseUrl + path,
      { 
        headers: this.httpOptions.headers, 
        params, 
        responseType: response as 'json' 
      }).pipe(
        map(value => {
          return value.data;
        })
      );
  }
  public post<T>(path: any, model: any, response = 'json'): Observable<T> {
    return this.httpClient.post<GenericMessageResponse<T>>(environment.api.baseUrl + path,
      model, { headers: this.httpOptions.headers, responseType: response as 'json' })
      .pipe(
        map(value => {
          return value.data;
        })
      );
  }
  public put<T>(path: any, model: any, params?: any, response = 'json'): Observable<T> {
    return this.httpClient.put<GenericMessageResponse<T>>(environment.api.baseUrl + path,
      model, { headers: this.httpOptions.headers, params, responseType: response as 'json' })
      .pipe(
        map(value => {
          return value.data;
        })
      );
  }
  public delete<T>(path: any, params?: any, response = 'json'): Observable<T> {
    return this.httpClient.delete<GenericMessageResponse<T>>(environment.api.baseUrl + path,
      { headers: this.httpOptions.headers, params, responseType: response as 'json' })
      .pipe(
        map(value => {
          return value.data;
        })
      );
  }
}
